<div class="tw-w-[95%] -tw-mt-3 tw-px-4 tw-pb-6 tw-pt-10 tw-bg-white tw-mx-auto tw-shadow-z1 tw-relative tw-z-[5] tw-rounded-2.5">

  <div class="tw-w-full tw-absolute -tw-left-7 -tw-top-3">
    <img class="tw-w-32" src="https://cdn.cureskin.com/app/img/gamification/confetti_tip.gif" alt="confetti">
  </div>

  <ng-container [ngSwitch]="dayIndex">
    <!-- Day 1 -->
    <ng-container *ngSwitchCase="0">
      <p class="tw-text-200 tw-text-[#D1903E] tw-italic tw-mb-1" i18n="@@day1Completed">🔥 Day 1 completed!</p>
      <h1 class="tw-font-lexend tw-text-700 tw-font-extrabold tw-mb-1.5 -tw-tracking-[1px]" i18n="@@greatStart">Great Start!</h1>
      <p class="tw-text-300 tw-text-gray-400 tw-font-500 tw-tracking-[0.02em] tw-mb-[46px] tw-font-body">
        <span *ngIf="username" class="tw-capitalize">{{ username }}, </span><span i18n="@@day1Message">you've taken the first step toward healthier skin! Keep showing up!</span>
      </p>
    </ng-container>

    <!-- Day 2 -->
    <ng-container *ngSwitchCase="1">
      <p class="tw-text-200 tw-text-[#D1903E] tw-italic tw-mb-1" i18n="@@day2Completed">🎉 Day 2 completed!</p>
      <h1 class="tw-font-lexend tw-text-700 tw-font-extrabold tw-mb-1.5 -tw-tracking-[1px]" i18n="@@twoDaysInARow">Two days in a row!</h1>
      <p class="tw-text-300 tw-text-gray-400 tw-font-500 tw-tracking-[0.02em] tw-mb-[46px] tw-font-body" i18n="@@day2Message">
        Amazing, your skin's already getting used to this rhythm!
      </p>
    </ng-container>

    <!-- Day 3 -->
    <ng-container *ngSwitchCase="2">
      <p class="tw-text-200 tw-text-[#D1903E] tw-italic tw-mb-1" i18n="@@day3Completed">💪 Day 3 completed!</p>
      <h1 class="tw-font-lexend tw-text-700 tw-font-extrabold tw-mb-1.5 -tw-tracking-[1px]" i18n="@@buildingTheHabit">Building the Habit!</h1>
      <p class="tw-text-300 tw-text-gray-400 tw-font-500 tw-tracking-[0.02em] tw-mb-[46px] tw-font-body" i18n="@@day3Message">
        Habits form with repetition – and you're right on track!
      </p>
    </ng-container>

    <!-- Day 4 -->
    <ng-container *ngSwitchCase="3">
      <p class="tw-text-200 tw-text-[#D1903E] tw-italic tw-mb-1" i18n="@@day4Completed">🥳 Day 4 completed!</p>
      <h1 class="tw-font-lexend tw-text-700 tw-font-extrabold tw-mb-1.5 -tw-tracking-[1px]" i18n="@@halfwayThere">Halfway There!</h1>
      <p class="tw-text-300 tw-text-gray-400 tw-font-500 tw-tracking-[0.02em] tw-mb-[46px] tw-font-body" i18n="@@day4Message">
        You're four days strong. Just three more to complete your challenge!
      </p>
    </ng-container>

    <!-- Day 5 -->
    <ng-container *ngSwitchCase="4">
      <p class="tw-text-200 tw-text-[#D1903E] tw-italic tw-mb-1" i18n="@@day5Completed">🙌 Day 5 completed!</p>
      <h1 class="tw-font-lexend tw-text-700 tw-font-extrabold tw-mb-1.5 -tw-tracking-[1px]" i18n="@@fiveDaysStraight">Five days straight!</h1>
      <p class="tw-text-300 tw-text-gray-400 tw-font-500 tw-tracking-[0.02em] tw-mb-[46px] tw-font-body" i18n="@@day5Message">
        You're creating a powerful routine. Keep the rhythm going!
      </p>
    </ng-container>

    <!-- Day 6 -->
    <ng-container *ngSwitchCase="5">
      <p class="tw-text-200 tw-text-[#D1903E] tw-italic tw-mb-1" i18n="@@day6Completed">🔥 Day 6 completed!</p>
      <h1 class="tw-font-lexend tw-text-700 tw-font-extrabold tw-mb-1.5 -tw-tracking-[1px]" i18n="@@oneStepAway">One Step away!</h1>
      <p class="tw-text-300 tw-text-gray-400 tw-font-500 tw-tracking-[0.02em] tw-mb-[46px] tw-font-body" i18n="@@day6Message">
        Just one more day to complete your 7-day streak. Finish strong!
      </p>
    </ng-container>
  </ng-container>

  <div class="tw-px-4 tw-py-6 tw-bg-gradient-light-yellow-to-white tw-w-full tw-rounded-lg tw-flex tw-relative tw-pt-6">
    <img src="https://cdn.cureskin.com/app/img/gamification/bulb.gif" class="tw-w-8 tw-absolute -tw-top-4 tw-left-4 tw-rounded-full" alt="idea bulb">
    <p class="tw-text-200"><span class="tw-font-bold" i18n="@@skincareTipLabel">Skincare Tip: </span> <span> {{ selectedDayTip }} </span></p>
  </div>
</div>
